import {
  CardBody,
  CardEnd,
  CardFeatureBody,
  CardIntro,
  CardLargeType,
  CardTitle,
} from './Cards';

export const cardsMap = {
  ContentfulCarouselBodyCard: CardBody,
  ContentfulCarouselBodyCardImage: CardFeatureBody,
  ContentfulCarouselBodyCardNumbered: CardFeatureBody,
  ContentfulCarouselIntroCard: CardIntro,
  ContentfulCarouselLargeTypeCard: CardLargeType,
  ContentfulCarouselTitleCard01: CardTitle,
  ContentfulCarouselTitleCard02: CardTitle,
  ContentfulCarouselTitleCard03: CardTitle,
  ContentfulLink: CardEnd,
};

export const cardOptionsMap = {
  ContentfulCarouselBodyCardImage: { feature: 'image' },
  ContentfulCarouselBodyCardNumbered: { feature: 'numbered' },
  ContentfulCarouselTitleCard01: { header: 1 },
  ContentfulCarouselTitleCard02: { header: 2 },
  ContentfulCarouselTitleCard03: { header: 3 },
};
